import { Card } from 'react-bootstrap';
import classNames from 'classnames';
import Background from '@/components/common/Background';
import SubtleBadge from '@/components/common/SubtleBadge';
import CountUp from 'react-countup';
import formatCompactNumber from '@/helpers/formatCompactNumber';

const StatisticsCard = ({ stat, ...rest }) => {
  const {
    title,
    value,
    decimal,
    compact,
    suffix,
    prefix,
    // valueClassName,
    // linkText,
    // link,
    badgeText,
    badgeBg,
    image,
    className
  } = stat;
  return (
    <Card className={classNames(className, 'overflow-hidden')} {...rest}>
      <Background image={image} className="bg-card" />
      <Card.Body className="position-relative">
        <h6>
          {title}
          {badgeText && (
            <SubtleBadge bg={badgeBg} pill className="ms-2">
              {badgeText}
            </SubtleBadge>
          )}
        </h6>
        <div
          className={classNames(
            // valueClassName,
            'display-4 fs-3 fw-normal mt-3'
          )}
        >
          {compact ? (
            <span>{formatCompactNumber(value)}</span>
          ) : (
            <CountUp
              start={0}
              end={value ?? 0}
              duration={2.75}
              suffix={suffix}
              prefix={prefix}
              separator=","
              decimals={decimal ? 2 : 0}
              decimal="."
            />
          )}
        </div>
        {/* <Link to={link} className="fw-semi-bold fs--1 text-nowrap">
          {linkText}
          <FontAwesomeIcon
            icon="angle-right"
            className="ms-1"
            transform="down-1"
          />
        </Link> */}
      </Card.Body>
    </Card>
  );
};

export default StatisticsCard;
